import React, { useState } from "react";
import { useEffect } from "react";
import { useForm } from "react-hook-form";
import { useSelector } from "react-redux";
import { Table } from "react-bootstrap";
import InputWrapper from "../../citizen/AVPForms/layout/inputWrapper";
import { recommendation, remarks, siteInspRecommendation } from "../../citizen/TCPForms/data";
import { Checkbox, FormControlLabel } from "@mui/material";
import RemarksDialog from "../ReusableComponets/RemarksDialog";
import { getDocumentByFileStoreId } from "@egovernments/digit-ui-libraries/src/utils/fileType";
import useModal from "@egovernments/digit-ui-libraries/src/hooks/obps/SwalModals/useModal";
import ButtonWrapper from "../../citizen/AVPForms/components/Button";
import SortingAlphabatically from "../../citizen/AVPForms/reusableComponents/SortingAlphbatically";

const inputWidth = 200;

const DocumentSection = ({
  formData,
  setUpdatedDocuments,
  updatedDocuments,
  handleChange,
  isCitizen,
  setIsPreviewLoading,
  setDataRecommendation,
  dataRecommendation,
  callDocumentDetailsAPI,
  onSelect,
  handleNoWorkflow,
  attachedDocs,
  docType = "mandatory",
  detailData,
  ComposableComponent = false,
  formType = "COMMON",
  developerRemarks,
  setError,
  isNocModule = false,
  isFromDashboard = false,
  setDeveloperRemarks = null,
}) => {
  console.log("fromstep2new", formData, detailData, isNocModule);

  const { documents } = useSelector((state) => state.formMT);
  const logApiDocs = detailData?.[detailData?.length - 1]?.documentDetails?.documents;
  const checklist = formData?.checklist;
  const defaultValues = {};

  const Modal = useModal();
  const { handleSubmit, control, watch, setValue, getValues, reset, trigger } = useForm({ defaultValues });
  // const attachedDocs = formData?.documents;
  console.log("loggingAttachedDocs", attachedDocs, logApiDocs, logApiDocs?.length);
  const excludedTypes = ["signature", "applicantPhoto", "sitePhoto"];
  const excludedTypesForDocSection = [...excludedTypes, "sitePhoto"];
  const isUpdateAllowed = !["APPROVED", "REJECTED", "MAKE_PAYMENT", "UPLOAD_DOC"].includes(formData?.status);
  // If NOT LANDUSE, then we exclude kmlFile
  if (formType !== "LANDUSE") {
    excludedTypes.push("kmlFile");
    excludedTypesForDocSection.push("kmlFile");
  }

  const documentSection = attachedDocs?.filter((doc) => !excludedTypes.includes(doc.documentType) && doc.isNoc !== "true");
  const applicantPhoto = attachedDocs?.filter((doc) => doc.documentType === "applicantPhoto" && doc.isNoc !== "true");
  // const docSection = attachedDocs?.filter(
  //   (doc) =>
  //     !excludedTypesForDocSection.includes(doc.documentType) && doc.isNoc !== "true" && (docType === "mandatory" ? doc.isMandatory : !doc.isMandatory)
  // );
  const docSection = attachedDocs?.filter(
    (doc) =>
      !excludedTypesForDocSection.includes(doc.documentType) &&
      doc.isNoc !== "true" &&
      (docType === "mandatory" ? doc.isMandatory || doc.documentType === "Experience Certificate" : !doc.isMandatory)
  );

  console.log("DOC SECITON 74", docSection, docType, attachedDocs, formType);

  const remainingDocTypes = ["signature", "applicantPhoto", "sitePhoto"];
  if (formType !== "LANDUSE") remainingDocTypes.push("kmlFile");

  const remainingDocs = attachedDocs?.filter((doc) => remainingDocTypes.includes(doc.documentType) && doc.isNoc !== "true");

  const [open, setOpen] = useState(false);
  const [selectedDoc, setSelectedDoc] = useState(null);
  const [loading, setLoading] = useState(true);
  const [saveRecommendation, setSaveRecommendation] = useState(false);
  const [renderedDocs, setRenderedDocs] = useState([]);
  const [finalDocuments, setFinalDocuments] = useState(documentSection || []);
  const officerRemarks = useSelector((state) => state.remarksDialog);
  console.log("officerRemarksFromDialog", officerRemarks);

  const restructureDocuments = (documents) => {
    return Object.values(documents).map((doc) => {
      // Destructure the necessary fields and return the required format
      const {
        id,
        documentType,
        fileStoreId,
        documentRemarks,
        documentSubtype,
        documentUid,
        additionalDetails,
        auditDetails,
        remarks,
        documentStatus,
      } = doc;

      return {
        id,
        documentType,
        fileStoreId,
        documentRemarks,
        documentSubtype,
        documentUid,
        additionalDetails: { ...additionalDetails },
        remarks,
        documentStatus,
        auditDetails,
      };
    });
  };
  const tenantId = Digit.ULBService.getCurrentTenantId();
  const updateApiCall = Digit.Hooks.obps.useObpsAPI(tenantId);
  // const finalDocs = officerRemarks?.documents;
  // const documentsFromUpdate = formData?.documents;
  // console.log("recommendationsFrom", officerRemarks?.documents);
  const handleEditRemarks = (doc) => {
    setSelectedDoc(doc);
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };
  // useEffect(() => {
  //   setValue("documents", documents);
  // }, [documents]);
  console.log("formdartaFromDOcs", formData);
  function updateFinalDocs(documentSection, updateObject) {
    const seen = new Set();
    return documentSection
      .map((doc) => {
        const statusKey = `${doc.documentType}documentStatus`;
        const remarksKey = `${doc.documentType}documentRemarks`;

        return {
          ...doc,
          documentStatus: updateObject[statusKey] || doc.documentStatus,
          documentRemarks: updateObject[remarksKey] || doc.documentRemarks,
        };
      })
      .filter((doc) => {
        if (!doc.fileStoreId || seen.has(doc.fileStoreId)) return false; // Skip if fileStoreId is empty or already seen
        seen.add(doc.fileStoreId);
        return true;
      });
  }

  // Helper function to check if HTML content is truly empty
  const isHTMLEmpty = (html) => {
    if (!html) return true;
    // Remove HTML tags and check if remaining text is empty
    const stripped = html.replace(/<[^>]*>/g, "").trim();
    return stripped.length === 0;
  };

  const onSubmit = async (data) => {
    console.log("dataFromSubmitDocs", data, finalDocuments);

    if (docType === "mandatory") {
      if (!developerRemarks) {
        setError(true);
        return;
      } else {
        if (setDeveloperRemarks) {
          setDeveloperRemarks(developerRemarks);
        }
        setError(false);
      }
    }
    const nocDocuments = formData?.documents?.filter((doc) => doc.isNoc === "true") || [];
    const result = updateFinalDocs(documentSection, data);

    const hasNonAcceptedDocs = result.some((doc) => doc.documentStatus == "Not accepted");

    if (hasNonAcceptedDocs && data?.recommendation === "Approval") {
      Modal("Unauthorized Action", "This action is prohibited as some of the documents are marked as Not Accepted.", "error");
      return;
    }

    const finalResult = [...result, ...applicantPhoto, ...remainingDocs];
    const finalResultupdated = [...result, ...remainingDocs, ...nocDocuments];

    const recommendationValue = data?.recommendation;

    await callDocumentDetailsAPI(developerRemarks, recommendationValue, finalResult);

    setUpdatedDocuments(finalResult);
    setDataRecommendation(recommendationValue);
    // console.log(finalResult,finalResultupdated,"finalResult123",result,applicantPhoto,nocDocuments);

    handleNoWorkflow(finalResultupdated);
  };
  const handleBlurEvent = (e, doc) => {
    const fileStoreId = doc.fileStoreId;
    const { name, value } = e.target;
    const fieldMapping = {
      documentStatus: "",
      documentRemarks: "",
    };
    // const fieldName = name?.match(/(.*)(documentStatus|documentRemarks)/)?.[1]; // Extract the field name without Status or Remarks
    const fieldName = name?.includes("Status") ? "documentStatus" : "documentRemarks";
    console.log("nameFromEVnt", name, value, fileStoreId, fieldName);
    if (fieldName) {
      console.log("nameFromEvent:", name, value, fileStoreId, fieldName);

      const index = documentSection.findIndex((doc) => doc.fileStoreId === fileStoreId);
      const watchRemark = watch(`${doc.documentType}documentRemarks`);
      const watchStatus = watch(`${doc.documentType}documentStatus`);
      console.log("watchRemark", watchRemark);

      // console.log("updatedNewDocFromStatus", updatedDoc);
      if (index !== -1) {
        // const updatedDoc = {
        //   ...documentSection[index],
        //   [fieldName]: value, // Dynamically update using the matched key
        //   updatedAt: new Date().toISOString(),
        // };
        const updatedDoc = {
          ...documentSection[index],
          documentRemarks: watchRemark, // Dynamically update using the matched key
          documentStatus: watchStatus, // Dynamically update using the matched key
        };
        console.log("updatedNewDoc:", updatedDoc);
        setFinalDocuments((prev) => [...prev, updatedDoc]);
        // setUpdatedDocuments((prevDocuments) => [...prevDocuments.slice(0, index), updatedDoc, ...prevDocuments.slice(index + 1)]);
      }
    } else {
      console.warn("Invalid field name:", name);
    }
  };
  const handleStatusChange = (e, doc) => {
    const isRemarkValidation = e.target.name?.includes("Remarks");
    if (!isRemarkValidation) {
      const status = getValues(`${doc.documentType}documentStatus`);
      const docType = doc.documentType;
      console.log("fromStatusChange", doc.documentType, status);
      // const status = watch(`${doc.documentType}Status`);
      if (status == "Accepted") {
        setValue(`${doc.documentType}documentRemarks`, "Document accepted", { shouldValidate: true });
        trigger(`${doc.documentType}documentRemarks`);
        const watchRemark = watch(`${docType}documentRemarks`);
        const watchStatus = watch(`${docType}documentStatus`);
        console.log("watchRemark", watchRemark);
        const index = documentSection.findIndex((item) => item?.fileStoreId === doc.fileStoreId);

        const updatedDoc = {
          ...documentSection[index],
          documentRemarks: watchRemark, // Dynamically update using the matched key
          documentStatus: watchStatus, // Dynamically update using the matched key
        };
        console.log("updatedNewDocFromStatus", updatedDoc);

        // setFinalDocuments((prev) => [...prev, updatedDoc]);

        // )
      }

      // const inputElement = document.querySelector(`[name="${documentType}documentRemarks"]`);
      // console.log("inputElement", inputElement);

      // if (inputElement) {
      //   const changeEvent = new Event("change", { bubbles: true });
      //   inputElement.dispatchEvent(changeEvent);
      // }
    } else {
      return;
    }
  };
  const handleOthersCase = (doc) => {
    const remarks = getValues(`${doc.documentType}documentRemarks`);
    if (remarks == "Others") {
      setSelectedDoc(doc);
      setOpen(true);
    } else {
      return;
    }
  };
  const handleChangeEvent = (e, doc) => {
    console.log("fromCHangeEvent", e.target.name, e.target.value);
    handleStatusChange(e, doc);
    handleOthersCase(doc);
    handleBlurEvent(e, doc);
  };

  //   // Watch all document statuses
  // const documentStatuses = docSection.map(
  //   (doc) => watch(`${doc.documentType}documentStatus`) || doc.documentStatus
  // );

  // // Check conditions
  // const hasNotAccepted = documentStatuses.some(
  //   (status) => status === "Not accepted"
  // );

  // const allAccepted =
  //   documentStatuses.length > 0 &&
  //   documentStatuses.every((status) => status === "Accepted");

  // // Filter recommendation options
  // const filteredRecommendationOptions = siteInspRecommendation.filter((item) => {
  //   // Hide Approval if any document is Not accepted
  //   if (item.value === "Approval" && hasNotAccepted) {
  //     return false;
  //   }

  //   // Optional:
  //   // Show Approval only when all accepted
  //   if (item.value === "Approval" && !allAccepted) {
  //     return false;
  //   }

  //   return true;
  // });

  const documentStatuses = docSection?.map((doc) => watch(`${doc.documentType}documentStatus`) || doc.documentStatus);

  // Check conditions
  const allAccepted = documentStatuses?.length > 0 && documentStatuses?.every((status) => status === "Accepted");

  const hasNotAccepted = documentStatuses?.some((status) => status === "Not accepted");

  // Filter recommendation options
  const filteredRecommendationOptions = siteInspRecommendation?.filter((item) => {
    // If ALL Accepted → show ONLY Approval
    if (allAccepted) {
      return item.value === "Approval";
    }

    // If one or more Not accepted → hide Approval
    if (hasNotAccepted) {
      return item.value !== "Approval";
    }

    // Default case
    return true;
  });

  useEffect(() => {
    if (officerRemarks?.id) {
      setValue(`${officerRemarks?.documentType}documentRemarks`, officerRemarks?.remarks, { shouldValidate: true });
      trigger(`${officerRemarks?.documentType}documentRemarks`);
    }
  }, [officerRemarks.id]);

  return (
    <section className="">
      <form onSubmit={handleSubmit(onSubmit)}>
        <div className="table-container">
          <Table bordered hover responsive className="application-table">
            <thead className="customhead" style={{ backgroundColor: "#1F4A7C", color: "#fff", height: "20px" }}>
              <tr>
                <th className="fit-table-head">Sr.no</th>
                <th className="fit-table-head">Document Name</th>
                <th className="fit-table-head">Status</th>
                <th className="fit-table-head">Remarks</th>
                {/* <th style={{ minWidth: "fit-content" }}>Edit</th> */}
              </tr>
            </thead>
            <tbody>
              {docSection?.length > 0 ? (
                docSection?.map((doc, index) => {
                  const isRecommended = watch(`${doc.documentType}documentStatus`) === "Accepted";
                  // if (isRecommended) {
                  //   setValue(`${doc.documentType}documentRemarks`, null);
                  // }
                  console.log("isRecommended", isRecommended, doc.documentType, doc.documentStatus, doc.documentRemarks);

                  return (
                    <tr key={`${index}_${doc.id}`}>
                      <td>{index + 1}</td>
                      <td style={{ textAlign: "left" }}>
                        <a
                          style={{ cursor: "pointer", textDecoration: "none", color: "blue" }}
                          onClick={() => getDocumentByFileStoreId(doc.fileStoreId, setIsPreviewLoading)}
                          className="far-link"
                        >
                          {doc?.additionalDetails?.title || doc?.documentType}
                        </a>
                      </td>
                      {/* <td style={{ textAlign: "left" }}>{finalDocs[doc.id]?.documentStatus || doc?.documentStatus || ""}</td> */}
                      <td>
                        <span>
                          <InputWrapper
                            onBlur={(e) => handleChangeEvent(e, doc)}
                            hasLabel={false}
                            type="selectInput"
                            height={"24px"}
                            control={control}
                            data={SortingAlphabatically(recommendation)}
                            placeholder={"Select document status"}
                            name={`${doc.documentType}documentStatus`}
                            defaultValue={doc.documentStatus || ""}
                            mandatory
                            disabled={isNocModule}
                            width={"100%"}
                            validation={{
                              required: {
                                value: true,
                                message: "This field is required",
                              },
                            }}
                          />
                        </span>
                      </td>
                      {/* <td>{finalDocs[doc.id]?.remarks || doc?.remarks || ""}</td> */}
                      <td>
                        <span>
                          {/* <InputWrapper
                            onBlur={(e) => handleChangeEvent(e, doc)}
                            hasLabel={false}
                            height={"24px"}
                            type="selectInput"
                            control={control}
                            name={`${doc.documentType}documentRemarks`}
                            defaultValue={doc.documentRemarks || ""}
                            placeholder={"Enter remarks"}
                            data={remarks}
                            disabled={isRecommended || isNocModule}
                            mandatory
                            width={"100%"}
                            validation={{
                              required: {
                                value: true,
                                message: "This field is required",
                              },
                            }}
                          /> */}
                          <InputWrapper
                            onBlur={(e) => handleChangeEvent(e, doc)}
                            hasLabel={false}
                            height={"24px"}
                            type="selectInput"
                            control={control}
                            name={`${doc.documentType}documentRemarks`}
                            defaultValue={doc.documentRemarks || ""}
                            placeholder={"Enter remarks"}
                            data={remarks}
                            disabled={isRecommended || isNocModule}
                            mandatory
                            width={"100%"}
                            validation={{
                              required: {
                                value: true,
                                message: "Please select remarks",
                              },
                            }}
                          />
                        </span>
                      </td>
                      {/* {!isCitizen && (
                        <td style={{ textAlign: "center" }}>
                          <div style={{ textAlign: "center" }}>
                            <Button
                              size="small"
                              sx={{ ml: 1, fontSize: "10px", alignContent: "center", display: "flex", color: "white" }}
                              variant="contained"
                              color="primary"
                              onClick={() => handleEditRemarks(doc)}
                            >
                              <span style={{ color: "white" }}>Edit</span>
                            </Button>
                          </div>
                        </td>
                      )} */}
                    </tr>
                  );
                })
              ) : (
                <div>No conditional document attached</div>
              )}
            </tbody>
          </Table>
        </div>
        {/* ComposableComponent  only remarks*/}
        {/* {ComposableComponent && <div style={{ marginTop: "24px" }}>{ComposableComponent({ control })}</div>} */}
        {ComposableComponent && (
          <div style={{ marginTop: "24px" }}>
            {ComposableComponent({
              control,
              options: filteredRecommendationOptions,
            })}
          </div>
        )}
        {ComposableComponent && isUpdateAllowed && docType === "mandatory" && !isFromDashboard && (
          <FormControlLabel
            control={<Checkbox checked={saveRecommendation} onChange={(e) => setSaveRecommendation(e.target.checked)} size="small" color="primary" />}
            label="Do you want to save selected recommendation?"
          />
        )}
        {!ComposableComponent && isUpdateAllowed && docType === "conditional" && !isFromDashboard && callDocumentDetailsAPI && (
          <FormControlLabel
            control={<Checkbox checked={saveRecommendation} onChange={(e) => setSaveRecommendation(e.target.checked)} size="small" color="primary" />}
            label="Do you want to save selected recommendation?"
          />
        )}
        {saveRecommendation && (
          <div style={{ textAlign: "center", marginTop: "24px" }}>
            <ButtonWrapper
              variant="contained"
              color="success"
              control={control}
              size="medium"
              label="Save"
              type="submit"
              sx={{ backgroundColor: "#157CB3" }}
            />
          </div>
        )}
      </form>
      <RemarksDialog open={open} handleClose={handleClose} doc={selectedDoc} />
    </section>
  );
};

export default DocumentSection;
